import axios from "axios"
import { API_BASE_URL } from "../shared/Config"

export interface SecurityLockPreviewResponse {
    maskedEmail: string
}

export interface SecurityLockError {
    status: number
    message: string
    code: string
}

function normalizeError(err: any): SecurityLockError {
    if (err?.code && typeof err?.status === "number") {
        return err as SecurityLockError
    }

    const status = err?.response?.status ?? 500
    const data = err?.response?.data

    return {
        status,
        message: data?.message ?? "Não foi possível processar a solicitação.",
        code: data?.code ?? "SECURITY_LOCK_FAILED",
    }
}

function assertPreviewResponse(data: unknown): SecurityLockPreviewResponse {
    const maskedEmail = (data as SecurityLockPreviewResponse)?.maskedEmail
    if (!maskedEmail || typeof maskedEmail !== "string") {
        throw normalizeError({
            response: {
                status: 500,
                data: {
                    message: "Não foi possível processar a solicitação.",
                    code: "SECURITY_LOCK_FAILED",
                },
            },
        })
    }
    return { maskedEmail }
}

export const SecurityLockService = {
    previewLockAccount: async function (token: string): Promise<SecurityLockPreviewResponse> {
        try {
            const response = await axios.post(`${API_BASE_URL}/security/lock-account/preview`, { token })
            return assertPreviewResponse(response.data)
        } catch (err) {
            throw normalizeError(err)
        }
    },

    confirmLockAccount: async function (token: string): Promise<{ success: boolean }> {
        try {
            const response = await axios.post(`${API_BASE_URL}/security/lock-account`, { token })
            return response.data
        } catch (err) {
            throw normalizeError(err)
        }
    },
}
